import { render, staticRenderFns } from "./breadcrumb.vue?vue&type=template&id=6ac8944b&"
import script from "./breadcrumb.vue?vue&type=script&lang=ts&"
export * from "./breadcrumb.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports